import { render, staticRenderFns } from "./SpanLayout.vue?vue&type=template&id=5a6f263e&scoped=true"
import script from "./SpanLayout.vue?vue&type=script&lang=js"
export * from "./SpanLayout.vue?vue&type=script&lang=js"
import style0 from "./SpanLayout.vue?vue&type=style&index=0&id=5a6f263e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6f263e",
  null
  
)

export default component.exports